export const environment = {
  production: true,
  apiUrl: 'https://apps.theguru.co/api/v1/',
  // apiUrl: "https://cms.guruexperience.info/api/v1/",
  apiDomainName: '',
  appId: 0,
  appTitle: 'Holocaust Museum LA Tours',
  appShortTitle: 'Tours',
};
